import { render, staticRenderFns } from "./PointRuleForm.vue?vue&type=template&id=134490e2&scoped=true"
import script from "./PointRuleForm.vue?vue&type=script&lang=js"
export * from "./PointRuleForm.vue?vue&type=script&lang=js"
import style0 from "./PointRuleForm.vue?vue&type=style&index=0&id=134490e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134490e2",
  null
  
)

export default component.exports